import type { DefaultContext, FetchResult, MutationFunctionOptions } from '@apollo/client';
import type {
  CreateHangingProtocolMutation,
  CreateHangingProtocolMutationVariables,
} from 'generated/graphql';
import { useMutation } from '@apollo/client';

import { CREATE_HANGING_PROTOCOL, GET_ALL_HANGING_PROTOCOLS } from 'modules/Apollo/queries';
import { WithApolloContext } from 'modules/Apollo/types';

export const useCreateHangingProtocol = ({
  context,
}: WithApolloContext): ((
  options?: MutationFunctionOptions<
    CreateHangingProtocolMutation,
    CreateHangingProtocolMutationVariables,
    DefaultContext
  >
) => Promise<FetchResult<CreateHangingProtocolMutation>>) => {
  const [createHangingProtocol] = useMutation<
    CreateHangingProtocolMutation,
    CreateHangingProtocolMutationVariables
  >(CREATE_HANGING_PROTOCOL, {
    refetchQueries: [{ query: GET_ALL_HANGING_PROTOCOLS }],
    awaitRefetchQueries: true,
    context,
  });
  return createHangingProtocol;
};
